import { environment } from 'src/environments/environment';

export class EnvHelper {
    public static IsOnAgencyPortal(): boolean {
        return environment.agencyPortal === true;
    }
}
